'use client'
import React, { FC, ReactNode } from 'react'
import { ChakraProvider, Text } from '@chakra-ui/react'
import { customTheme } from '@/styles/theme'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { API_KEY } from '@/constants'

interface AppProvidersProps {
  children: ReactNode
}

const AppProviders: FC<AppProvidersProps> = ({ children }) => {
  if (!API_KEY) {
    return <Text color="red">NEXT_PUBLIC_GOOGLE_MAPS_API_KEY not found</Text>
  }

  return (
    <ChakraProvider resetCSS theme={customTheme}>
      <ToastContainer
        className="Toastify__toast-container"
        hideProgressBar
        pauseOnHover={false}
        draggable={false}
      />
      {children}
    </ChakraProvider>
  )
}

export default AppProviders
